import React from 'react'
import { ContextType } from '../types/advanced-grid.types'
import RowRender from '../row-render'
import { withGridContext } from '../providers'

interface Props {}

/**
 *
 * @param param0
 * @returns
 */
const TableBody: React.FC<Props & ContextType> = ({
    columnKeys,
    columns,
    data,
    dataLoaded,
    rowDataProcessor
}) => {
    return (
        <tbody>
            {dataLoaded &&
                data &&
                data.map((rowData, key) => {
                    const rowDataToRender =
                        rowDataProcessor && typeof rowDataProcessor === 'function'
                            ? rowDataProcessor(rowData)
                            : rowData
                    return (
                        <RowRender
                            columns={columns}
                            columnKeys={columnKeys}
                            key={`row-${key}`}
                            rowData={rowDataToRender}
                            rowKey={key}
                        />
                    )
                })}
        </tbody>
    )
}

TableBody.defaultProps = {
    data: []
}

export default withGridContext(TableBody)
